import assets from '../../apis/assets.api';
export const getAssetsByIdStartsWith = (searchById) => {
    return assets.get('/assets', { params: { searchById } });
};
export const getAssetById = (id, curveType) => assets.get(`/assets/${encodeURIComponent(id)}`, {
    params: {
        assetType: curveType,
    },
});
export const deleteAssets = () => {
    return assets.delete('/assets', { timeout: 10000 });
};
